import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const add_blog = createAsyncThunk(
  "blog/add_blog",
  async (blog, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/blog-add", blog, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const update_blog = createAsyncThunk(
  "blog/update_blog",
  async (blog, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/blog-update", blog, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const get_blogs = createAsyncThunk(
  "blog/get_blogs",
  async ({ page, parPage, searchValue }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(
        `/blog-gets?page=${page}&parPage=${parPage}&searchValue=${searchValue}`,
        {
          withCredentials: true,
        }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const get_blog = createAsyncThunk(
  "blog/get_blog",
  async (blogId, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/single-blog-byId/${blogId}`, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const delete_blog = createAsyncThunk(
  "blog/delete_blog",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await api.delete(`/blog/${id}`, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const blogReducer = createSlice({
  name: "blog",
  initialState: {
    successMessage: "",
    errorMessage: "",
    loader: false,
    blogs: [],
    blogData: null,
    totalBlogs: 0,
  },
  reducers: {
    messageClear: (state) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },
  extraReducers: {
    // Add blog
    [add_blog.pending]: (state) => {
      state.loader = true;
    },
    [add_blog.rejected]: (state, action) => {
      state.loader = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [add_blog.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
      state.blogs.push(payload.blog); // Add new blog
    },

    // Update blog
    [update_blog.pending]: (state) => {
      state.loader = true;
    },
    [update_blog.rejected]: (state, action) => {
      state.loader = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [update_blog.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
      state.blogData = payload.blogData;
    },

    // Get all blogs
    [get_blogs.pending]: (state) => {
      state.loader = true;
    },
    [get_blogs.rejected]: (state, action) => {
      state.loader = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [get_blogs.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.blogs = payload.blogData;
      state.totalBlogs = payload.totalBlogs;
    },

    // Get single blog
    [get_blog.pending]: (state) => {
      state.loader = true;
    },
    [get_blog.rejected]: (state, action) => {
      state.loader = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [get_blog.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.blogData = payload.blogPage;
    },

    // Delete blog
    [delete_blog.pending]: (state) => {
      state.loader = true;
    },
    [delete_blog.rejected]: (state, action) => {
      state.loader = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [delete_blog.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
      state.blogs = state.blogs.filter((blog) => blog._id !== payload.blogId);
    },
  },
});

export const { messageClear } = blogReducer.actions;
export default blogReducer.reducer;
